import { render, staticRenderFns } from "./BArquivo.vue?vue&type=template&id=6a404804"
import script from "./BArquivo.vue?vue&type=script&lang=js"
export * from "./BArquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports